import React, { useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { OrbitControls, Grid, PerspectiveCamera } from '@react-three/drei';
import * as THREE from 'three';
import { useIDEStore } from '../../stores/ideStore';

const GameObjectProxy = ({ obj, isSelected, onClick }: any) => {
  const mesh = useRef<THREE.Mesh>(null!);
  
  // Convert basic props to position (mocking layout)
  const position: [number, number, number] = [0, 0, 0]; 
  
  // Different shapes for different types
  let geometry = <boxGeometry args={[1, 1, 1]} />;
  let color = isSelected ? '#375eab' : '#666666';
  
  if (obj.type === 'Camera') {
    geometry = <coneGeometry args={[0.5, 1, 4]} />;
    color = isSelected ? '#375eab' : '#aaaaaa';
  } else if (obj.type === 'Light') {
    geometry = <sphereGeometry args={[0.3, 8, 8]} />;
    color = '#ffff00';
  }

  return (
    <mesh
      ref={mesh}
      position={position}
      onClick={(e) => {
        e.stopPropagation();
        onClick(obj.id);
      }}
    >
      {geometry}
      <meshBasicMaterial color={color} wireframe={true} transparent opacity={0.8} />
    </mesh>
  );
};

export const ThreeScene = () => {
  const { gameObjects, selectedObjectId, setSelectedObject } = useIDEStore();

  return (
    <div className="w-full h-full bg-[#1e1e1e]">
      <Canvas
        shadows
        gl={{ antialias: true }}
        onCreated={({ gl }) => {
          gl.setClearColor(new THREE.Color('#1e1e1e'));
        }}
      >
        <PerspectiveCamera makeDefault position={[5, 5, 5]} fov={50} />
        <OrbitControls makeDefault enableDamping dampingFactor={0.1} rotateSpeed={0.5} />
        
        <ambientLight intensity={0.5} />
        <pointLight position={[10, 10, 10]} />
        
        <Grid 
          infiniteGrid 
          fadeDistance={50} 
          fadeStrength={5} 
          cellSize={1} 
          sectionSize={5} 
          sectionColor="#444444" 
          cellColor="#222222" 
        />
        
        {gameObjects.map((obj: any) => (
          <GameObjectProxy
            key={obj.id}
            obj={obj}
            isSelected={obj.id === selectedObjectId}
            onClick={setSelectedObject}
          />
        ))}
        
        <axesHelper args={[5]} />
      </Canvas>
    </div>
  );
};